export const NOTIFICATIONS_TABLE = {
    'NOTIFICATIONS.COLUMN.CLIENT': 'Client',
    'NOTIFICATIONS.COLUMN.COMPANY': 'Companie',
    'NOTIFICATIONS.COLUMN.NOTIFICATION': 'Notificare',
    'NOTIFICATIONS.COLUMN.DATE': 'Dată',
    'NOTIFICATIONS.COLUMN.READ': 'Citită',
    'NOTIFICATIONS.ACTION.MARK_AS_READ': 'Marchează ca citită',
    'NOTIFICATIONS.ACTION.MARK_AS_UNREAD': 'Marchează ca necitită'
};
